// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","route__info":"route__info-sZp3Z","row":"row-1_z4D","arrow_container":"arrow_container-vPIqn","totalDuration":"totalDuration-3x4Fy"};